<div class="developer-buttons">
  <button [routerLink]="['/developer', 'users']">Users</button>
  <button [routerLink]="['/developer', 'companies']">Companies</button>
  @if (showServiceGroupButton | async) {
    <button [routerLink]="['/developer', 'servicegroups']">ServiceGroups</button>
  }
  <button [routerLink]="['/developer', 'facilities']">Facilities</button>
  <button [routerLink]="['/developer', 'installations']">Installations</button>
  @if (showAccessClaimsButton | async) {
    <button [routerLink]="['/developer', 'accessclaimsgroups']">AccessClaimsGroups</button>
  }
</div>
